module.exports = __webpack_public_path__ + "static/media/howto.88eeea86.md";